<template>
  <div>
    <esg-table-without-meta :items="items"
                            :fields="fields"
                            :striped="false"
                            max-height="450px"
                            size="xs">
      <template #cell(cost_type)="{item, items, field, row, col, value}">
        <td v-if="item.rowspan"
            :rowspan="item.rowspan"
            class="text-center">{{ value === 'O' ? 'OPEX' : 'CAPEX' }}
        </td>
        <td v-else
            style="display: none"></td>
      </template>
      <template #cell(abatement_method_name)="{item, items, field, row, col, value}">
        <td :class="{subtotal: value === '소계'}"
            class="text-center">{{ value }}
        </td>
      </template>
      <template #cell(cost_total)="{item, items, field, row, col, value}">
        <td :class="{ subtotal: item.abatement_method_name === '소계'}"
            class="text-center">{{ formatNumber(value / 10e8, 0, 2) }}
        </td>
      </template>
      <template #cell(share)="{item, items, field, row, col, value}">
        <td :class="{ subtotal: item.abatement_method_name === '소계'}"
            class="text-center">{{ formatNumber(value * 100, 0, 2) + '%' }}
        </td>
      </template>
      <template #footer>
        <tr>
          <td colspan="2"
              class="text-center total">합계
          </td>
          <td class="text-center total">{{ formatNumber(total / 10e8, 0, 2) }}</td>
          <td class="text-center total">100%</td>
        </tr>
      </template>
    </esg-table-without-meta>
  </div>
</template>
<script>
import EsgTableWithoutMeta from "@/components/esg/base/EsgTableWithoutMeta.vue";

export default {
  components: { EsgTableWithoutMeta },
  props: {
    type: {
      type: String,
      default: ''
    },
    corporation: {
      type: Object,
      default() {
        return {}
      }
    },
    businessLocation: {
      type: Object,
      default() {
        return {}
      }
    },
    firstYear: {
      type: Number,
      default: 2018,
    },
    lastYear: {
      type: Number,
      default: 2050,
    }
  },
  watch: {
    corporation: {
      deep: true,
      handler() {
        this.fetchData();
      }
    },
    businessLocation: {
      deep: true,
      handler() {
        this.fetchData();
      }
    },
    lastYear: {
      handler() {
        this.fetchData();
      }
    }
  },
  created() {
    this.fetchData();
  },
  // 감축 수단별 비용
  methods: {
    async fetchData() {
      try {
        this.loading = true;

        let args = {
          years: Array.from({ length: this.lastYear - this.firstYear + 1 }, (_, index) => this.firstYear + index),
          groupKeys: ['cost_type', 'abatement_method_value', 'abatement_method_name']
        };
        this.corporation.name && (args.corporations = [this.corporation.code])
        this.businessLocation.name && (args.businessLocations = [this.businessLocation.business_location_code])

        let data = new FormData()
        data.append('path', 'esg/cost/main');
        data.append('json', JSON.stringify([args]));

        this.abortController = new AbortController();
        let response = await axios.post('esg/lca/run/python/chart-data', data, {
          headers: { Authorization: accessToken() },
          signal: this.abortController.signal
        });

        // If there is no data, return
        if (!response.data.data) {
          this.series = [];
          return;
        }

        // Parse JSON data
        const tableData = JSON.parse(response.data.data)[0].data

        // Set row span for 'cost_type' field
        let items = [];
        let headerRow = null;
        tableData.forEach((item, index) => {
          items.push(item);

          if (index === 0 || item.cost_type !== tableData[index - 1].cost_type) {
            headerRow = item;
            headerRow.rowspan = 2;
            headerRow.subtotal = headerRow.cost_total;
          } else {
            headerRow.rowspan += 1;
            headerRow.subtotal += item.cost_total;
          }

          if (index === tableData.length - 1 || item.cost_type !== tableData[index + 1].cost_type) {
            items.push({ abatement_method_name: '소계', cost_total: headerRow.subtotal })
          }
        });

        // Calculate total and push it to the items
        this.total = tableData.reduce((a, b) => a + b.cost_total, 0)

        // Calculate share of each cost
        items.forEach(item => item.share = item.cost_total / this.total)

        this.items = items;
      } catch (error) {
        this.loading = false;
        await this.showError(error)
      } finally {
        this.loading = false;
      }
    },
  },
  data() {
    return {
      loading: false,
      total: 0,
      items: [],
      fields: [
        {
          name: "cost_type",
          label: "CAPEX/OPEX",
          list: true,
        },
        {
          name: "abatement_method_name",
          label: "감축수단",
          list: true,
        },
        {
          name: "cost_total",
          label: "비용",
          list: true,
          formatter: val => this.formatNumber(val / 10e8)
        },
        {
          name: "share",
          label: "비율",
          list: true,
        },
      ]
    }
  },
}
</script>

<style scoped>
>>> td.total,
td.subtotal {
  background-color: #FAFAFA;
  font-weight: 700 !important;
}
</style>
